import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pb-2 item-li" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.role)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(`flex ${
        _ctx.isMobile ? 'flex-col' : 'max-h-fit gap-10'
      } justify-center`)
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userItems(), (item, i) => {
            return (_openBlock(), _createElementBlock("ul", {
              class: _normalizeClass(`flex topbar-li`),
              key: i
            }, [
              (!_ctx.isMobile)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass([{active: item.name === _ctx.routeName}, {active: item.groupRouteFrom && (item.groupRouteFrom === _ctx.$route.meta.groupRouteFrom)}])
                  }, [
                    _createElementVNode("li", _hoisted_2, [
                      _createVNode(_component_Button, {
                        class: "btn-simple",
                        onClick: item.command
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            name: item.icon,
                            class: "text-primary-400 mr-2"
                          }, null, 8, ["name"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.generic", { pt: item.label, en: item.labelEN })), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ], 2))
                : (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    class: "bg-h-primary-100 rounded-md border mb-2 active:bg-h-secondary-100 w-full",
                    onClick: item.command
                  }, [
                    _createVNode(_component_Button, {
                      label: item.label,
                      icon: "pi pi-angle-right",
                      class: "btn-simple p-button-sm"
                    }, null, 8, ["label"])
                  ], 8, _hoisted_3))
            ]))
          }), 128))
        ], 2)
      ]))
    : _createCommentVNode("", true)
}